import { Card, Layout, Tag, Text } from '@loadsmart/loadsmart-ui'
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import isJson from 'common/helpers/isJSON'
import {
  IntegrationTestCaseDetail,
  IntegrationTestCaseInputDefinition,
} from 'common/types/kraken-core/IntegrationTest'
import isEmpty from 'lodash.isempty'
import FileViewer from 'molecules/FileViewer/FileViewer'
import { useState } from 'react'

export interface IntegrationTestCaseDetailInputDefinitionProps {
  testCase: IntegrationTestCaseDetail
  onChange: (propertyName: string, value: any) => void
}

export default function IntegrationTestCaseDetailInputtDefinition(
  props: IntegrationTestCaseDetailInputDefinitionProps
) {
  const [definition, setDefinition] = useState<IntegrationTestCaseInputDefinition>({
    payload: props.testCase.input_definition?.payload || '',
    headers: props.testCase.input_definition?.headers || {},
  })

  const onChangeCallback = (value: IntegrationTestCaseInputDefinition) => {
    props.onChange('input_definition', value)
  }

  const handleOnPayloadChange = (value: string) => {
    // Encode
    const encoded = btoa(value)
    onChangeCallback({
      ...definition,
      payload: encoded,
    })
  }

  const handleOnHeadersChange = (value: any) => {
    onChangeCallback({
      ...definition,
      headers: value,
    })
  }

  const handleOnMocksChange = (value: any) => {
    props.onChange('http_mocks', value)
  }

  return (
    <Card>
      <Card.Title>
        <Layout.Stack>
          <Text variant="heading-sm-bold">Input Definition</Text>
          <Text variant="body">To define what are the input arguments</Text>
        </Layout.Stack>
      </Card.Title>
      <Card.Separator />
      <Card.Body>
        <div>
          <Accordion>
            <AccordionSummary>
              <Layout.Group>
                <Text>Payload</Text>
                {!isEmpty(definition.payload) ? <Tag variant="accent">Has definition</Tag> : null}
              </Layout.Group>
            </AccordionSummary>
            <AccordionDetails>
              <FileViewer
                content={atob(definition?.payload || '')}
                contentType=""
                options={{}}
                onChange={value => {
                  handleOnPayloadChange(value)
                }}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary>
              <Layout.Group>
                <Text>Headers</Text>
                {!isEmpty(definition.headers) ? <Tag variant="accent">Has definition</Tag> : null}
              </Layout.Group>
            </AccordionSummary>
            <AccordionDetails>
              <FileViewer
                content={JSON.stringify(definition.headers)}
                contentType="application/json"
                options={{}}
                onChange={value => {
                  if (isJson(value)) {
                    handleOnHeadersChange(JSON.parse(value))
                  }
                }}
              />
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary>
              <Layout.Group>
                <Text>Mocks</Text>
                {!isEmpty(props.testCase.http_mocks) ? (
                  <Tag variant="accent">Has definition</Tag>
                ) : null}
              </Layout.Group>
            </AccordionSummary>
            <AccordionDetails>
              <FileViewer
                content={JSON.stringify(props.testCase.http_mocks)}
                contentType="application/json"
                options={{}}
                onChange={value => {
                  if (isJson(value)) {
                    handleOnMocksChange(JSON.parse(value))
                  }
                }}
              />
            </AccordionDetails>
          </Accordion>
        </div>
      </Card.Body>
    </Card>
  )
}
